import React from 'react'
import './settings.css'

const Settings = () => {
  return (
    <div>
        Settings
    </div>
  )
}

export default Settings